<header class="bg-surface/90 text-text-strong fixed top-0 left-0 right-0 z-50 border-b border-subtle backdrop-blur-xl">
  <nav class="container mx-auto px-6 lg:px-10 py-3 flex justify-between items-center">
    <a [routerLink]="getBasePath()" fragment="home" class="font-mono text-sm tracking-wider text-accent hover:text-accent-glow transition-colors">
      vnribeiro<span class="text-muted">.dev</span>
    </a>

    <!-- Desktop Menu -->
    <div class="hidden md:flex items-center gap-1">
      @for (link of navLinks; track link.fragment) {
        <a [routerLink]="getBasePath()" [fragment]="link.fragment"
          [ngClass]="{ 'text-accent bg-accent/5 border-accent/20': activeSection === link.fragment, 'border-transparent': activeSection !== link.fragment }"
          [attr.aria-current]="activeSection === link.fragment ? 'page' : null"
          class="px-3 py-1.5 rounded border text-xs font-mono text-muted-light hover:text-accent hover:bg-accent/5 transition-all duration-300">
          {{ link.label | translate }}
        </a>
      }

      <!-- Language -->
      <div class="ml-4 flex items-center rounded border border-subtle overflow-hidden font-mono text-xs">
        @for (lang of availableLanguages; track lang) {
          <button (click)="switchLanguage(lang)"
            [ngClass]="{ 'bg-accent text-surface font-medium': currentLanguage === lang, 'text-muted hover:text-accent': currentLanguage !== lang }"
            class="px-2.5 py-1 transition-all duration-300 cursor-pointer">
            {{ getLanguageLabel(lang) }}
          </button>
        }
      </div>
    </div>

    <!-- Mobile Menu Button -->
    <div id="mobileMenuToggle" class="md:hidden">
      <button (click)="toggleMobileMenu()" class="text-muted-light hover:text-accent focus:outline-none transition-colors" aria-label="Open menu">
        <i class="fas text-base transition-transform duration-300"
          [ngClass]="isMobileMenuOpen ? 'fa-times rotate-180' : 'fa-bars rotate-0'">
        </i>
      </button>
    </div>
  </nav>

  <!-- Mobile Menu -->
  @if (isMobileMenuOpen) {
    <div id="mobileMenu" class="md:hidden bg-surface-50/98 border-t border-subtle backdrop-blur-xl">
      @for (link of navLinks; track link.fragment) {
        <a [routerLink]="getBasePath()" [fragment]="link.fragment"
          [ngClass]="{ 'text-accent bg-accent/5': activeSection === link.fragment }"
          [attr.aria-current]="activeSection === link.fragment ? 'page' : null"
          class="cursor-pointer block py-3 px-6 text-sm font-mono text-muted-light hover:text-accent hover:bg-accent/5 transition-all duration-300 border-b border-subtle/50">
          <span class="text-accent/40 mr-2">//</span>{{ link.label | translate }}
        </a>
      }
      <div class="py-3 px-6">
        <div class="inline-flex items-center rounded border border-subtle overflow-hidden font-mono text-xs">
          @for (lang of availableLanguages; track lang) {
            <button (click)="switchLanguage(lang)"
              [ngClass]="{ 'bg-accent text-surface font-medium': currentLanguage === lang, 'text-muted hover:text-accent': currentLanguage !== lang }"
              class="px-2.5 py-1 transition-all duration-300 cursor-pointer">
              {{ getLanguageLabel(lang) }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</header>
